import { useState } from 'react';
import { Button } from 'react-bootstrap';
import CommonModal from '../common/commonModal/CommonModal';
import IsValidChangePasswordData from '../ValidationChecker/changePasswordValidation';
import { changePassword } from '../../api/authApi';
import ReactNotifications from '../common/reactNotifications/ReactNotifications';
import * as utilConstants from '../../utils/constants/utilsConstants';

const ChangePassword = () => {
  const [changePasswordErrors, setChangePasswordErrors] = useState({});
  const [loading, setLoading] = useState(false);
   const [touchedFields, setTouchedFields] = useState({});
  const columns = [
    { header: 'Current Password', accessor: 'current_password' },
    { header: 'New Password', accessor: 'new_password' },
    { header: 'Confirm Password', accessor: 'confirm_password' },
  ];
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });

  const handleChange = (e) => {
    let { name, value } = e.target;
    const sanitizedValue = value.replace(/\s/g, '');

    setTouchedFields(prev => ({ ...prev, [name]: true }));

    const updatedData = { ...modalData, [name]: sanitizedValue };
    setModalData(updatedData);

    const { errors } = IsValidChangePasswordData(updatedData);

    const filteredErrors = {};
    Object.keys(errors).forEach((key) => {
      if (touchedFields[key] || key === name) {
        filteredErrors[key] = errors[key];
      }
    });

    setChangePasswordErrors(filteredErrors);
  };

  const handleSave = () => {
    const { isValid, errors } = IsValidChangePasswordData(modalData);
    if (isValid) {
      setLoading(true);
      changePassword(modalData, (res) => {
        setLoading(false);
        if (res?.status === true || res?.status === 200) {
          ReactNotifications(res?.message || res?.data?.message, utilConstants.sucessState200);
          setShowModal(false);
          setModalData({ current_password: '', new_password: '', confirm_password: '' });
          setChangePasswordErrors({});
        } else {
          if (res?.data?.errors) {
            setChangePasswordErrors(res?.data?.errors);
          } else {
            ReactNotifications(res?.message || 'Unable to change password', utilConstants.getErrorStatus);
          }
        }
      });
    } else {
      setChangePasswordErrors(errors);
      setTouchedFields({
        current_password: true,
        new_password: true,
        confirm_password: true
      });
    }
  };

  return (
    <>
      <div>
        <Button className='p-2 px-3 flex border ' variant="outline" onClick={() => setShowModal(true)}>
          Change Password
        </Button>
      </div>

      <CommonModal
        show={showModal}
        handleClose={() => {
          setShowModal(false);
          setModalData({
            current_password: '',
            new_password: '',
            confirm_password: ''
          });
          setTouchedFields({});
          setChangePasswordErrors({});
        }}
        handleSave={handleSave}
        columns={columns}
        mode='other'
        title={'Change Password'}
        data={modalData}
        handleChange={handleChange}
        errors={changePasswordErrors}
        saveButtonText={'Change'}
      />
    </>
  );
};

export default ChangePassword;
